import { Box, Typography } from "@mui/material";
import { textXS } from "../../../../shared/constants";
import { useWiserTheme } from "../../../../hooks/useWiserTheme";
import { getProjectStatusTagColors } from "../../../../shared/theme/wiserThemeHelpers";
import { getTagChipSx } from "../../style";

export const ProjectStatusTag = ({ status }: { status: string }) => {
  const { darkModeActive } = useWiserTheme();
  if (!status) return null;

  const statusColors = getProjectStatusTagColors(status, darkModeActive);
  return (
    <Box sx={getTagChipSx(statusColors.bg)}>
      <Typography sx={textXS(500, statusColors.text)}>
        {status.toTitleCase()}
      </Typography>
    </Box>
  );
};
